import React from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';

const Wrapper = styled.div`
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 0px 16.875px -1.40625px rgba(0, 0, 0, 0.08);
  height: 79px;
  width: 100%;
  margin-bottom: 8px;
  .wrapper-outer-div {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-right: 155px;
    #block1 {
      flex: 14.5%;
      div {
        display: flex;
        align-items: center;
        padding-left: 10px;
      }
      span {
        display: flex !important;
        gap: 4px;
        padding-right: 18px;
      }
    }
    #block2 {
      flex: 1;
      span {
        display: flex !important;
      }
    }
    #block3 {
      flex: 1;
      span {
        display: flex !important;
      }
    }
    .ant-skeleton-header .ant-skeleton-avatar-lg {
      width: 54px !important;
      height: 54px !important;
    }
  }
`;
const FormSummaryListingSkeleton: React.FC = () => {
  return (
    <Wrapper className="skeleton-form-listing">
      {/* <SkeletonCustom height="135px" width="135px" diameter="50%" /> */}
      <div className="wrapper-outer-div">
        <div id="block1">
          <div>
            <span>
              <Skeleton style={{ width: '12px', height: '12px', display: 'flex', alignItems: 'center', marginRight: '3em' }} active avatar={true} />
            </span>
            <span style={{ display: 'flex', flexDirection: 'column' }}>
              <Skeleton.Button style={{ width: '130px', height: '18px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
              <Skeleton.Button style={{ width: '100px', height: '14px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
              <Skeleton.Button style={{ width: '50px', height: '12px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
            </span>
          </div>
        </div>
        <div id="block2">
          <span>
            <Skeleton.Button style={{ width: '100px', height: '16px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
          </span>
        </div>
        <div id="block3">
          <span>
            <Skeleton.Button style={{ width: '110px', height: '16px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
          </span>
        </div>
        <div id="block4">
          <span>
            <Skeleton.Button style={{ width: '120px', height: '16px', borderRadius: '8px' }} active size={'small'} shape={'square'} block={true} />
          </span>
        </div>
      </div>
    </Wrapper>
  );
};

export default FormSummaryListingSkeleton;
